import type { IOption } from '@user/components/Filters'
import type { ActivitySummaryFilterSet } from './typings'
import { ServiceConfig } from '@user/store/services/config'

export const baseUrl = `${ServiceConfig.baseAPIUrl}/${ServiceConfig.activities.activitySummary}`
export const topStatsUrl = `${ServiceConfig.baseAPIUrl}/${ServiceConfig.activities.activities}/${ServiceConfig.activities.topStats}`

export const defaultCreatedDate: IOption = {
  value: -30,
  label: 'Last 30 days',
}

export const dateOptions: IOption[] = [
  {
    value: -7,
    label: 'Last 7 days',
  },
  defaultCreatedDate,
  {
    value: -90,
    label: 'Last 90 days',
  },
]

export const defaultOrderBy = 'id desc'

export const clearedFilters: ActivitySummaryFilterSet = {
  appliedCount: 0,
  normalizedFilters: [],
  orderBy: defaultOrderBy,
  filters: {
    activityTypeId: {
      value: null,
      type: 'singleSelect',
      propertyIsString: false,
      propertyName: 'activityTypeId',
    },
    ownerId: {
      type: 'multiSelect',
      propertyIsArray: false,
      propertyIsString: false,
      propertyName: 'ownerId',
      hideModeSelectField: true,
      value: { mode: 'any', options: [] },
    },
    createdDate: {
      value: null,
      type: 'limitedDate',
      propertyName: 'createdDate',
    },
    dueDate: {
      value: null,
      type: 'limitedDate',
      propertyName: 'dueDate',
    },
    startDate: {
      value: null,
      type: 'limitedDate',
      propertyName: 'startDate',
    },
    salesFunnelId: {
      value: null,
      type: 'singleSelect',
      propertyIsString: false,
      propertyName: 'salesFunnelId',
    },
    salesTeamIds: {
      type: 'multiSelect',
      propertyIsArray: false,
      propertyIsString: false,
      propertyName: 'salesTeamId',
      hideModeSelectField: true,
      value: { mode: 'any', options: [] },
    },
  },
}
